import script from "./BrandedParagraphElementProduction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrandedParagraphElementProduction.vue?vue&type=script&lang=js"
export * from "./BrandedParagraphElementProduction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrandedParagraphElementProduction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/text-element/BrandedParagraphElementProduction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f43d2614"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f43d2614', __exports__)) {
    api.reload('f43d2614', __exports__)
  }
  
}


export default __exports__